// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_ExtraRemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /implantacao/extra_remover — tira um item só desta jornada (Full). Chamado NS 2026-0079. */
import { registerContract } from './validate'

export interface Implantacao_ExtraRemoverInput {
franquia_id?: number
item_chave?: string
}

registerContract('Implantacao_ExtraRemoverInput', {
  franquia_id: { type: 'number',  required: false },
  item_chave:  { type: 'string',  required: false },
})
